import React from 'react'
import { formatFeeToString } from '@/helpers/fees'
import { usePlanFees } from '@/hooks/usePlanFees'
import { FeeItem } from './FeeItem'
import { PlanDetails } from '@/contexts/plans'

export interface TierFeesProps {
  planTier: PlanDetails
}

function getText({ metadata }: PlanDetails) {
  const maximum_tpv = Math.round(metadata?.maximum_tpv || 0) / 1000
  const minimum_tpv = Math.round(metadata?.minimum_tpv || 0) / 1000

  if (metadata?.maximum_duration && maximum_tpv) {
    return `Válidas durante ${metadata.maximum_duration} dias ou até vender ${maximum_tpv} mil reais.`
  }

  if (minimum_tpv && maximum_tpv) {
    return `Vendas mensais de R$ ${minimum_tpv} mil a R$ ${maximum_tpv} mil`
  }

  if (maximum_tpv) {
    return `Vendas mensais até R$ ${maximum_tpv} mil`
  }

  return `Vendas mensais acima de R$ ${minimum_tpv} mil`
}

export const TierFees = ({ planTier }: TierFeesProps) => {
  const fees = usePlanFees(planTier.name)

  if (!fees) return null

  const description = getText(planTier)

  return (
    <div className="flex overflow-hidden flex-col md:flex-row text-center rounded-16 border border-display-300">
      <p className="flex justify-center items-center md:p-24 py-8 px-16 w-full text-display-900 bg-display-100 ton-paragraph-14">
        {description}
      </p>

      <ul className="grid flex-shrink-0 grid-cols-3 gap-8 items-end py-16 px-12 w-full max-w-[312px] font-bold">
        <FeeItem label="DÉBITO" value={formatFeeToString(fees[0])} />
        <FeeItem label="CRÉDITO" value={formatFeeToString(fees[1])} />

        <FeeItem label={`CRÉDITO 12X`} value={formatFeeToString(fees[12])} />
      </ul>
    </div>
  )
}
